<template>
  <div class="bg-color-box" :class="'search-tab-container--' + color">
    <IndexSearch :store-config="storeConfig"></IndexSearch>

    <div class="service-new-list-tab tab">
      <span class="backhome" @click="navigateCategory()" :class="{ active: navId == 'recommend' }">
        <img src="../../../../ui/assets/mobile/images/icon-home.png" alt="" />
      </span>
      <ul class="tab-nav">
        <swiper :options="navSwiperOption" ref="navSwiper">
          <li
            v-for="category in showShopCategories"
            :key="category.id"
            @click="navigateCategory(category)"
            :class="{ active: navId == category.id }"
          >
            <swiper-slide>{{ category.name }}</swiper-slide>
          </li>
        </swiper>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex"
import * as reportDict from "../../../constants/report-dictonary"
import IndexSearch from "../../common/IndexSearch.vue"
import { swiper, swiperSlide } from "vue-awesome-swiper"

export default {
  props: ["navId"],

  components: {
    IndexSearch,
    swiper,
    swiperSlide
  },

  data() {
    return {
      navSwiperOption: {
        freeMode: true,
        slidesPerView: 5,
        preventClicks: false
      }
    }
  },

  computed: {
    ...mapGetters(["showShopCategories", "storeConfig"]),

    color() {
      if (this.navId) {
        if (this.navId === "game") {
          return "blue"
        }

        if (this.navId === "vip") {
          return "yellow"
        }

        if (this.navId === "zone") {
          return "orange"
        }
      }

      return "blue"
    }
  },

  methods: {
    ...mapActions(["reportUserAction"]),

    navigateCategory(category) {
      // 若在游戏tab，进入/gameZoneList
      if (category) {
        if (category.id == "game") {
          // this.navId = category.id
          this.$emit("setNavId", category.id)

          this.$router.replace({
            path: "/gameZoneList",
            query: {
              ...this.$route.query,
              tab: category.id
            }
          })
        } else {
          // this.navId = category.id
          this.$emit("setNavId", category.id)
          this.$router.replace({
            path: "/tabList",
            query: {
              ...this.$route.query,
              tab: category.id
            }
          })
        }
      } else {
        this.$router.replace({ path: "/" })
        window.scrollTo(0, 0)
      }
      this.reportUserAction({
        iformat: `${reportDict.CLICK.NAV_TAB}_${category ? category && category.id : "recommend"}`
      })
    }
  }
}
</script>
